import { useState } from "react";
import { SiteHeader } from "./SiteHeader";
import { SiteFooter } from "./SiteFooter";
import { SideMenu } from "./SideMenu";
import { MobileBottomBar } from "./MobileBottomBar";
import { LeftSidebar, FloatingSupport } from "./LeftSidebar";

export const SiteLayout = ({ children, showFooter = true, showBottomBar = true }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <div className="min-h-screen flex flex-col text-white" style={{ background: "#0a1119" }}>
      <SiteHeader />
      <SideMenu open={menuOpen} onClose={() => setMenuOpen(false)} />
      <LeftSidebar />
      <main
        className="flex-1 flex flex-col pb-20 lg:pb-0 lg:pl-[88px] xl:pl-[112px]"
        data-testid="site-main"
      >
        <div className="flex-1">{children}</div>
        {showFooter && <SiteFooter />}
      </main>
      {showBottomBar && <MobileBottomBar onMenuClick={() => setMenuOpen(true)} />}
      <FloatingSupport />
    </div>
  );
};
